import BaseTitleIcon from '@/components/PHR/BaseTitleIcon';
import utils from '@/utils';
import { Form, Input } from 'antd';
import * as React from 'react';

export interface IInfoDetailProps {
  user: IUser;
}

const InfoDetail: React.FC<IInfoDetailProps> = ({ user, ...props }) => {
  //   const infoComponent = (
  //     <div className="mt-5 w-full h-auto overflow-y-scroll max-h-[75vh] px-4">
  //       <BaseTitleIcon src="/icons/Regular/User - icon.svg" title="Thông tin cá nhân" />
  //       {[
  //         { title: 'Mã tài khoản', value: user?.code },
  //         { title: 'Ngày sinh', value: utils.safeFormat(user?.birthday) },
  //         { title: 'Email', value: user?.email },
  //         {
  //           title: 'Địa chỉ',
  //           value: <span className="capitalize">{utils.safeAddress(user?.address)}</span>,
  //         },
  //         { title: 'Nghề nghiệp', value: user?.job },
  //         { title: 'Số thẻ BHYT', value: '' },
  //         { title: 'Thời hạn BHYT', value: '' },
  //         { title: 'SĐT người liên hệ', value: user?.phone },
  //       ].map((d: any, i: number) => {
  //         return <BaseItemKeyValue key={i} keyName={d.title} value={d?.value} />;
  //       })}
  //       <BaseTitleIcon src="/icons/Regular/Home - icon.svg" title="Danh sách gia đình" />
  //       <BaseItemKeyValue
  //         key={'_1'}
  //         keyName="Mã gia đình"
  //         value={
  //           <div className="flex">
  //             <span className="underline">{user?.family?.code}</span>
  //             &nbsp;&nbsp;
  //             <PHR_bt_Expand onClick={openFamilyScreen} />
  //           </div>
  //         }
  //       />

  //       <BaseTitleIcon src="/icons/Regular/Doctor - icon.svg" title="Người phụ trách" />
  //       <BaseItemKeyValue key={'_2'} keyName="Bác sỹ" value={doctor} />
  //     </div>
  //   );
  return (
    <div className="px-4 w-full max-h-[75vh]">
      <Form layout="vertical" className="pb-4">
        <BaseTitleIcon src="/icons/Regular/User - icon.svg" title="Thông tin cá nhân" />
        {[
          { title: 'Mã tài khoản', value: user?.code },
          { title: 'Ngày sinh', value: utils.safeFormat(user?.birthday) },
          { title: 'Email', value: user?.email },
          {
            title: 'Địa chỉ',
            value: utils.safeAddress(user?.address),
          },
          { title: 'Nghề nghiệp', value: user?.job },
          { title: 'Số thẻ BHYT', value: '' },
          { title: 'Thời hạn BHYT', value: '' },
          { title: 'SĐT người liên hệ', value: user?.phone },
        ].map((d: any, i: number) => {
          return (
            <Form.Item key={i.toString()} label={d.title} className="mb-1">
              <Input value={d.value} disabled />
            </Form.Item>
          );
        })}

        <BaseTitleIcon src="/icons/Regular/Home - icon.svg" title="Danh sách gia đình" />
        <Form.Item label={'Mã gia đình'} className="mb-1">
          <Input value={user?.family?.code} disabled />
        </Form.Item>

        <BaseTitleIcon src="/icons/Regular/Doctor - icon.svg" title="Người phụ trách" />
        <Form.Item label={'Bác sỹ'} className="mb-1">
          <Input value={user?.family?.doctor?.username} disabled />
        </Form.Item>

        {/* <BaseItemKeyValue
          key={'_1'}
          keyName="Mã gia đình"
          value={
            <div className="flex">
              <span className="underline">{user?.family?.code}</span>
              &nbsp;&nbsp;
              <PHR_bt_Expand onClick={openFamilyScreen} />
            </div>
          }
        /> */}
      </Form>
    </div>
  );
};
export default InfoDetail;
